import { create } from "zustand";
import { getData } from "../utils/formHelpers";
import { TypeEfficiencyParts } from "../../app/types/genericTables.types";

type useEfficiencyPartsTypes = {
  efficiencyPartsList: TypeEfficiencyParts[];
  get: (id: TypeEfficiencyParts["id"]) => TypeEfficiencyParts | undefined;
  query: string;
  setQuery: (query: string) => void;
  fetchAll: () => void;
  loading: boolean;
};

export const useEfficiencyParts = create<useEfficiencyPartsTypes>(
  (set, get) => ({
    loading: false,
    efficiencyPartsList: [],
    query: "",
    setQuery: (query) => set({ query }),
    get: (id) =>
      get().efficiencyPartsList.find(
        (efficiencyPart) => efficiencyPart.id === id
      ),
    fetchAll: async () => {
      set({ loading: true });
      try {
        const endpoint = "/generic/PartesEficiencia";
        const { data: response } = await getData(endpoint);

        set(() => ({
          efficiencyPartsList: response,
          loading: false,
        }));
      } catch (error) {
        console.error("Error fetching useEfficiencyParts:", error);
        set({ loading: false });
      }
    },
  })
);
